import React, { useState, useEffect } from "react"; // Router
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import SignOutPage from "../../pages/SignOutPage";
import UnAuthorizedPage from "../../pages/UnAuthorizedPage";

// Router
import Routes from "./routes";

// utility
import { getCookie, redirectToLoginPage } from "../../helpers/utils";

// Components
import SessionTimeOut from "./SessionTimeOut";
import Header from "../Header";
import Footer from "../Footer";
import AppData from "./AppData";
import Loader from "../Loader";
//import axios from "axios";

// Styles
import "./index.scss";

// Internationalization
import { IntlProvider } from "react-intl";

import messages_en from "../../languages/en.json";
import messages_es from "../../languages/es.json";
import { fetchLogin } from "../../redux/actions/loginAction";
import { useDispatch, useSelector } from "react-redux";
import { entitiesOriginsObject } from "../../constants";

const messages = {
  en: messages_en,
  es: messages_es,
};

// const defaultLanguage =
//   localStorage.getItem("userLanguage") || navigator.language;
//const language = defaultLanguage.split(/[-_]/)[0];  // language without region code
const language = "en"; // this should be removed once language translation is ready.

export const Context = React.createContext();

export const UserContext = React.createContext({ isLoggedIn: false });

const Wrapper = (props) => {
  const dispatch = useDispatch();
  const loginStates = useSelector((state) => state.logins);
  const [locale, setLocale] = useState(language);
  const [message, setMessage] = useState(messages[language]);
  const [appData, setAppData] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [loggInDetails, setLoggInDetailsn] = useState({
    isLOggedIn: false,
    logginMsg: "Loading Entity Portal....",
    staff: "",
    membershipStaff: "",
    userDetails: "",
  });
  const [serverErr] = useState({
    serverErr: false,
    serverErrMsg: "",
  });
  const selectLanguage = (event) => {
    const newLocale = event.target.value;
    setLocale(newLocale);
    setMessage(messages[newLocale]);
    localStorage.setItem("userLanguage", newLocale);
  };

  const handleAppData = (status) => {
    setAppData(status);
  };
  useEffect(() => {
    if (getCookie("_e_p_u")) {
      dispatch(fetchLogin());
    }
  }, []);

  useEffect(() => {
    if (
      loginStates &&
      loginStates.login &&
      loginStates.login.data &&
      loginStates.login.data.staff &&
      loginStates.login.data.memberStaff &&
      loginStates.login.data.userDetails
    ) {
      setLoggInDetailsn((loggInDetails) => ({
        ...loggInDetails,
        isLOggedIn: true,
        logginMsg: loginStates.login.msg,
        staff: loginStates.login.data.staff,
        membershipStaff: loginStates.login.data.memberStaff,
        userDetails: loginStates.login.data.userDetails,
      }));
    }
  }, [loginStates]);

  return (
    <Context.Provider value={{ locale, selectLanguage }}>
      <IntlProvider locale={locale} messages={message}>
        {!window?.location?.href?.includes("/signout") &&
          getCookie("_e_p_u") && (
            <UserContext.Provider value={isLoggedIn}>
              {<AppData handleAppData={handleAppData} />}
              {appData && (
                <div className="wrapper" id="wrapper">
                  {loggInDetails.isLOggedIn && getCookie("_e_p_u") && (
                    <div className="wrapper-route">
                      <Header />

                      <div className="wrapper-route-container">
                        <Routes loggInDetails={loggInDetails} />
                      </div>
                      {loginStates.isLoader && (
                        <div>
                          {loggInDetails.logginMsg}
                          <Loader globalWrap={true} />
                        </div>
                      )}
                      {!serverErr.serverErr && (
                        <div>{serverErr.serverErrMsg}</div>
                      )}

                      <Footer />
                    </div>
                  )}
                </div>
              )}

              <SessionTimeOut {...props} />
            </UserContext.Provider>
          )}
        {/* {!getCookie() && <UnAuthorizedPage />} */}
        {!getCookie("_e_p_u") &&
          !window?.location?.href?.includes("/signout") &&
          !window?.location?.href?.includes("/unauth") &&
          redirectToLoginPage()}

        <Router>
          <Switch>
            <Route excat path="/signout" component={SignOutPage} />
            <Route excat path="/unauth" component={UnAuthorizedPage} />
          </Switch>
        </Router>
      </IntlProvider>
    </Context.Provider>
  );
};

export default Wrapper;
